import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form } from "antd";
import { useCallback, useState } from "react";
import { FormServiceFieldHandlingExecuteCodeWhenNoTagManagerConsentIsGiven } from "./executeCodeWhenNoTagManagerConsentIsGiven.js";
import { FormServiceFieldHandlingSkipIfActiveNotice } from "./skipIfActiveNotice.js";
import { useFormService } from "../../../../../contexts/formService.js";
import { useI18n } from "../../../../../contexts/i18n.js";
import { FormValueDifferFromTemplateTag } from "../../../valueDifferFromTemplateTag.js";
const FormServiceFieldHandlingCodeOptOut = ()=>{
    const { __ } = useI18n();
    const { renderCodeMirror, essentialGroupId } = useFormService();
    const [ref, setRef] = useState();
    // CodeMirror does not support "display:none;", we need to hide it in a hacky way
    const createHiddenFormItemsWithCodeMirror = useCallback((visible)=>({
            opacity: visible ? undefined : 0,
            height: visible ? undefined : 0,
            margin: visible ? undefined : 0
        }), []);
    return /*#__PURE__*/ _jsx(Form.Item, {
        noStyle: true,
        shouldUpdate: (prevValues, nextValues)=>prevValues.group !== nextValues.group,
        children: ({ getFieldValue })=>{
            const visible = getFieldValue("group") !== essentialGroupId;
            return /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsxs(Form.Item, {
                        label: __("Code executed on opt-out"),
                        style: createHiddenFormItemsWithCodeMirror(visible),
                        children: [
                            /*#__PURE__*/ _jsx(Form.Item, {
                                name: "codeOptOut",
                                noStyle: true,
                                children: renderCodeMirror()
                            }),
                            /*#__PURE__*/ _jsx(FormServiceFieldHandlingSkipIfActiveNotice, {
                                name: "codeOptOut"
                            }),
                            /*#__PURE__*/ _jsx("div", {
                                ref: setRef,
                                children: /*#__PURE__*/ _jsx(FormValueDifferFromTemplateTag, {
                                    style: {
                                        marginTop: 10
                                    },
                                    form: "service",
                                    valueName: "codeOptOut",
                                    widthOfRef: ref,
                                    noBr: true,
                                    splitView: false
                                })
                            })
                        ]
                    }),
                    visible && /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ _jsx(FormServiceFieldHandlingExecuteCodeWhenNoTagManagerConsentIsGiven, {
                            name: "executeCodeOptOutWhenNoTagManagerConsentIsGiven"
                        })
                    })
                ]
            });
        }
    });
};
export { FormServiceFieldHandlingCodeOptOut };
